import React from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Badge,
  UncontrolledTooltip,
} from 'reactstrap';
import Collapsible from 'react-collapsible';
import VincularCanceladoContainer from '@common/vincularCancelado/vincular-cancelado.container';
import vialBanIcon from '@componentes/_util/icons/custom/vial-ban-icon.png';
import { etapasEnum, tipoMedicoEnum } from '@common/util/defaultValues';
import CheckCritico from './CheckCritico';
import CheckUrgente from './CheckUrgente';
import Medico from './Medico';
import DataPrevisaoEntrega from './DataPrevisaoEntrega';
import { calcIdade, mapGenero } from '../../../functions/general';
import './detalhes.styles.css';
import IntlMessage from '../../../helpers/intlMessage';

const DetalhesExamePage = (props) => (
  <div className="detalhes-exame">
    <Modal
      centered
      size="lg"
      className="modal-cancelado"
      isOpen={props.modalCancelados}
      toggle={() => props.toggleModalCancelados()}
      titulo="Vincular a exame Cancelado"
    >
      <ModalHeader toggle={() => props.toggleModalCancelados()}></ModalHeader>
      <ModalBody>
        <VincularCanceladoContainer altura={window.innerHeight - 215} />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => props.toggleModalCancelados()}>
          <IntlMessage id="dashboards.examDetails.cancel" />
        </Button>
      </ModalFooter>
    </Modal>
    <div style={{ position: 'absolute', width: '80px', marginLeft: '15px', marginTop: props.detalhes.pacienteNomeSocial ? '12px' : '5px' }}><span><i style={{ fontSize: props.detalhes.pacienteNomeSocial ? '36px' : '18px' }} className='fa fa-user'></i></span></div>
    <div className={props.detalhes.pacienteNomeSocial ? 'paciente-social' : 'paciente'}>
      <div className={props.detalhes.pacienteNomeSocial ? 'social collapse-header' : 'collapse-header'} onClick={props.abrirDetalhes}>
        <span className='registro-civil'>{props.config.same ? props.detalhes.nrMatriculaSame : props.detalhes.prontuario} - {props.detalhes.paciente}</span>
        <span>
          {props.detalhes.urgente && (
            <i className="fas fa-exclamation-triangle"></i>
          )}
          {props.detalhes.critico && <i className="fas fa-plus-circle"></i>}
          {props.detalhes.termoAnuenciaImpresso && (
            <span style={{ color: '#ffa500' }}><IntlMessage id="dashboards.examDetails.printedTermofConsent" /></span>
          )}
        </span>

        {props.detalhes.habilitadoCertificacao && (
          <span
            className={`collapse-right ${props.detalhes.certificado ? 'certificado' : ''
              }`}
          >
            <i className="mv-basico-certificado_digital"></i>
            {props.detalhes.certificado ? <IntlMessage id="dashboards.examDetail.certificate" /> : <IntlMessage id="dashboards.examDetail.noCertificate" />}
          </span>
        )}
      </div>

      {props.detalhes.pacienteNomeSocial && <div className={props.detalhes.pacienteNomeSocial ? 'social collapse-header' : 'collapse-header'} onClick={props.abrirDetalhes}>
        <span>
          <strong><IntlMessage id="dashboards.examDetails.socialName" /></strong>
          {props.detalhes.pacienteNomeSocial}
        </span>
      </div>}
    </div>
    <div className={props.detalhes.pacienteNomeSocial ? 'social collapse-icone' : 'collapse-icone'} style={{ top: '25px' }}>
      <div className="icone" onClick={props.abrirDetalhes}>
        <i
          className={
            'fas ' +
            (props.detalhesAberto ? 'fa-chevron-up' : 'fa-chevron-down')
          }
        ></i>
      </div>
    </div>

    <Collapsible open={props.detalhesAberto} transitionTime={850}>
      <Row className="detalhes-exame">
        <Card className="detalhes-exame">
          <Row>
            <Col className="detalhes-exame-col">
              <CardBody>
                <ul>
                  {props.detalhes.exame && <li>
                    <strong><IntlMessage id="dashboards.examDetails.exam" /></strong>
                    {` ${props.detalhes.exame}`}
                  </li>}
                  {props.detalhes.nrExame && <li>
                    <strong><IntlMessage id="dashboards.examDetails.numberExam" /></strong>
                    {props.detalhes.nrExame}
                  </li>}
                  {props.detalhes.dataNascimento && <li>
                    <strong><IntlMessage id="dashboards.examDetails.birthDate" /></strong>
                    {props.detalhes.dataNascimento} -{' '}
                    {calcIdade(props.detalhes.dataNascimento)}
                  </li>}
                  {props.detalhes.sexo && <li>
                    <strong><IntlMessage id="dashboards.examDetails.sex" /></strong>
                    {mapGenero(props.detalhes.sexo)}
                  </li>}
                  <li>
                    {props.detalhes.laudoAnterior &&
                      props.detalhes.laudoAnterior > 0 && (
                        <div style={{ marginTop: '4px' }}>
                          <strong className="laudoAnterior label">
                            <IntlMessage id="dashboards.examDetails.previousExamNumber" />
                          </strong>
                          <span>{` ${props.detalhes.numeroExameAnterior}`}</span>
                        </div>
                      )}
                  </li>
                </ul>
                <ul>
                  <li>
                    {props.etapa.etapa !== etapasEnum.MATERIAL && (
                      <Medico tipoMedico={tipoMedicoEnum.MEDICO} />
                    )}
                  </li>
                  <li>
                    {props.etapa.etapa !== etapasEnum.MATERIAL &&
                      props.etapa.etapa !== etapasEnum.CONGELACAO &&
                      props.etapa.etapa !== etapasEnum.ERRATA && (
                        <Medico tipoMedico={tipoMedicoEnum.REVISOR} />
                      )}
                  </li>
                  <li>
                    <strong>
                      <IntlMessage id="dashboards.examDetails.completionDate"/>{ props.getEtapa() + ': '}
                    </strong>
                    {` ${props.getDataConclusaoEtapa()} `}
                  </li>
                  <li>
                  <DataPrevisaoEntrega />
                  </li>              
                </ul>
                <ul>

                  {props.detalhes.nrPedido && <li>
                    <strong><IntlMessage id="dashboards.examDetails.request" /></strong>
                    {` ${props.detalhes.nrPedido} `}
                  </li>}

                  {props.detalhes.nrAtendimento && <li>
                    <strong><IntlMessage id="dashboards.examDetails.attendance" /></strong>
                    {props.detalhes.nrAtendimento}
                  </li>}

                  <li>
                    <strong><IntlMessage id="dashboards.examDetails.healthInsurance" /></strong>
                    {` ${props.detalhes.convenio}`}
                  </li>

                </ul>
                <ul>
                  <li onClick={props.toggleModalCancelados}>
                    <img
                      className="icon-vial-ban"
                      src={vialBanIcon}
                      alt="Laudos Cancelados"
                    />
                    <strong><IntlMessage id="dashboards.examDetails.canceled" /></strong>
                    {props.detalhes.qtdCancelados > 0 && (
                      <Badge
                        color="primary"
                        className="vial-ban-counter"
                        pill
                      >
                        {props.detalhes.qtdCancelados}
                      </Badge>
                    )}
                  </li>
                  <li
                    className="open-mensagem"
                    onClick={props.openMensagens}
                  >
                    <i
                      className="fas fa-envelope"
                      style={{ fontSize: '18px' }}
                    ></i>
                    <strong><IntlMessage id="dashboards.examDetails.messages" /></strong>
                  </li>
                  <li className="check-detalhes-laudo">
                    <CheckUrgente />
                    <CheckCritico />
                  </li>
                  <li id="iconeQtdExterno">
                    {props.detalhes.nrExameExterno && (
                      <div>
                        <UncontrolledTooltip
                          placement="left"
                          target="iconeQtdExterno"
                        >
                          <strong><IntlMessage id="dashboards.examDetails.block" /></strong>
                          {props.detalhes.qtdBlocoExterno}
                          <br />
                          <strong><IntlMessage id="dashboards.examDetails.blade" /></strong>
                          {props.detalhes.qtdLaminaExterno}
                        </UncontrolledTooltip>
                        <strong><IntlMessage id="dashboards.examDetails.externalExam" /></strong>
                        {` ${props.detalhes.nrExameExterno}`}
                      </div>
                    )}
                  </li>
                </ul>

              </CardBody>
            </Col>
          </Row>
        </Card>
      </Row >
    </Collapsible >
  </div >
);

export default DetalhesExamePage;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/detalhes.page.js